import { LanguagePicker, Modal, ModalTabs, PDFRenderer } from "components";

import { LocationGenerics } from "router/location";
import _ from "lodash";
import config from "config";
import { useFormik } from "formik";
import { useSearch } from "react-location";
import { useState } from "react";

const internalTabs = [
  {
    name: "Placing Slip",
    href: "PLACING_SLIP",
  },
  {
    name: "Cover Note",
    href: "COVER_NOTE",
  },
];

export default function ViewTreatyDocumentsContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [orderStatus, setOrderStatus] = useState("PLACING_SLIP");
  const searchParams = useSearch<LocationGenerics>();
  const id = searchParams?.id || "";

  const form = useFormik({
    initialValues: {
      lang: "en",
    },
    onSubmit() { },
  });


  const urls = {
    PLACING_SLIP: `${config.asset.uri}treaty_placing_cover_note/${btoa(
      JSON.stringify({
        treaty_id: id,
        doc_type: "Placing Slip",
      })
    )}`,
    COVER_NOTE: `${config.asset.uri}treaty_placing_cover_note/${btoa(
      JSON.stringify({
        treaty_id: id,
        doc_type: "Placing Slip",
      })
    )}`,
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Treaty Documents"
      description="Details of treaty documents are shown below"
      // hideActions
      hidePadding
    >
      <ModalTabs tabs={internalTabs} setOrderStatus={setOrderStatus} orderStatus={orderStatus} />
      <div className="space-y-4">
        <div className="bg-white rounded-2xl shadow">
          <PDFRenderer reloadToken={String(Date.now())} url={_.get(urls, orderStatus)} />
        </div>
      </div>

    </Modal>
  );
}


